'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Panel = require('@narvar/nth-block-panel');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var PickupLocationDetails = require('./components/PickupLocationDetails.js');
var PickupLocationNotFound = require('./components/PickupLocationNotFound.js');
var PrefetchData = require('./PrefetchData.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const PickupLocation = ({
  featureName,
  fixedPanelHeight,
  layout = FeatureLayout.PORTRAIT
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    state: {
      orderNumbers
    }
  } = nthHookContextPage.usePageContext();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const {
    locationPanelTitle
  } = nthHookTranslations.useTranslations();
  React.useEffect(() => {
    const orderNumber = orderNumbers && orderNumbers[0];
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      orderNumber,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
      pageOrderNumber: orderNumber,
      trackLayout: layout
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const {
    pickupLocation
  } = getCurrentShipment() || {};
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    featureName: featureName,
    fixedPanelHeight: fixedPanelHeight,
    sInner: {
      padding: 0
    },
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], {
      featureName: featureName
    }, locationPanelTitle)
  }, pickupLocation ? /*#__PURE__*/React__default["default"].createElement(PickupLocationDetails["default"], {
    pickupLocation: pickupLocation,
    layout: layout,
    featureName: featureName
  }) : /*#__PURE__*/React__default["default"].createElement(PickupLocationNotFound["default"], {
    featureName: featureName
  }));
};
const PickupLocationWithData = nthHookTranslations.withTranslationsProvider(PickupLocation, {
  translationKeys: ['locationPanelTitle']
});
const PickupLocationWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(PickupLocationWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports["default"] = PickupLocationWithPrefetchedData;
